/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';

import useManagerContext from '../context/useManagerContext';

export default function Table() {
  //
  const { managerDashboard, dates, loading } = useContext(useManagerContext);
  const columns = [
    { field: 'rep_name', headerName: 'KASS Name', width: 200, flex: 1 },
    { field: 'md_name', headerName: 'MD Name', width: 200 },
    { field: 'classification', headerName: 'Classification', width: 200 },
    { field: 'target', headerName: 'target', width: 200, type: 'number' },
    ...dates,
    { field: 'total_call', headerName: 'Calls', width: 200, type: 'number' },
    {
      field: 'rate',
      headerName: 'Rate',
      width: 200,
      type: 'number',
      renderCell: (data) => {
        if (data.row?.isPinnedRows) return '';

        return `${data.row.rate}%`;
      },
    },
    { field: 'total_planned', headerName: 'Planned', width: 200, type: 'number' },
    { field: 'total_deviation', headerName: 'Deviation', width: 200, type: 'number' },
  ];

  const pinnedRows = {
    bottom: managerDashboard.length
      ? [
          managerDashboard[0],
          managerDashboard[1],
          managerDashboard[2],
          managerDashboard[3],
          managerDashboard[4],
        ]
      : [],
    cellStyle: [{ fontWeight: 'bold' }],
  };

  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={12} md={12}>
        <div
          className='table-container'
          style={{ height: '800px', width: '118%', marginLeft: '20px', backgroundColor: '#fff' }}
        >
          <DataGridPro
            className='datagrid-per-md'
            rows={managerDashboard}
            columns={columns}
            loading={loading}
            pinnedRows={pinnedRows}
            experimentalFeatures={{ rowPinning: true }}
          />
        </div>
      </Grid>
    </Grid>
  );
}
